import { StandardDialogFooter } from "../../../../../pages/components/dialogs/standard-dialog/standard-dialog";
import React, { useEffect, useState } from "react";
import { MenuItem } from "@mui/material";
import Message from "../../../../../pages/components/message";
import { MessageSections } from "../../../../../pages/components/message/message";
import BarekamText from "../../../../../pages/components/text";
import { useAppSelector } from "../../../../../redux/store";
import { BarekamSelect } from "../../../../../pages/components/select/select";
import { OrderStateModel } from "../../../../../redux/reducers/static-data.reducers";
import { ActionDialogContent } from "./styled";
import { OrderStatesEnum } from "../../../../../pages/orders/enums/order-states.enum";
import { BarekamMenuItem, SelectedBarekamMenuItem } from "../../../../../pages/components/select/styled/orders";
import { WarehouseModel } from "../../../../../pages/shared/models/order/warehouse.model";
import { OrderGroupModel } from "../../../../../pages/shared/models/order/orderGroupModel";
import { getMessage } from "../../../../../pages/shared/helper-functions";
import { UserGroups } from "../../../../../router/router";

const StateSelect = ({ onSave, onCancel, orderStateId, groupData, error }: StateSelectDialogProps) => {
    const [selectedState, setSelectedState] = useState<OrderStateModel>();
    const { orderStates } = useAppSelector(state => state.staticDataReducer);
    const [filteredStates, setFilteredStates] = useState(orderStates);

    const [errors, setErrors] = useState<{ [key: string]: string }>({});

    const { messageCache, languageId } = useAppSelector(state => state.messagesReducer);

    const [warehouses, setWarehouses] = useState<WarehouseModel[]>([]);
    const { countries } = useAppSelector(state => state.staticDataReducer);
    const { currentUser } = useAppSelector((state) => state.currentUserReducer);
    const [warehouseId, setWarehouseId] = useState<number>();

    useEffect(() => {
        setWarehouses(() => {
            setWarehouseId(groupData?.destination?.warehouseId);
            if (error) {
                setErrors(error);
            }
            return countries
                .map(country => country.warehouse)
                .flat();
        })
    }, [countries])

    useEffect(() => {
        if (orderStateId !== 13) {
            const filteredStates = orderStates.filter((state) => state.orderStateId !== 5);
            setFilteredStates(filteredStates);
        } else {
            setFilteredStates(orderStates);
        }
    }, [orderStateId]);

    useEffect(() => {
        const currentUserGroup = currentUser?.userGroup?.userGroupId;

        switch (currentUserGroup) {
            case UserGroups.WAREHOUSE_WORKER:
                setFilteredStates(filteredStates.filter(state => state.isVisibleForWarehouse));
                break;
            case UserGroups.LOCAL_WAREHOUSE_WORKER:
                setFilteredStates(filteredStates.filter(state => state.isVisibleForLocalWarehouse && state.orderStateId !== 13 && state.orderStateId !== 5));
                break;
            case UserGroups.BAREKAM:
                setFilteredStates(filteredStates.filter(state => state.isVisibleForCustomer))
                break;
            default:
                setFilteredStates(filteredStates)
        }
    }, []);

    function onStateSelect(orderStateId: number) {
        setSelectedState(filteredStates.find(state => state.orderStateId === orderStateId))
    }

    function checkForSelectedState() {
        if (selectedState?.orderStateId === OrderStatesEnum.inIntermediateWarehouse && !warehouseId) {
            setErrors({ destination: 'required' });
        } else if (selectedState) {
            onSave(selectedState.orderStateId, warehouseId);
        } else {
            setErrors({ change_status_state: 'required' })
        }
    }

    return (
        <>
            <ActionDialogContent>
                <BarekamSelect
                    label={
                        <BarekamText variant={'1rem'}>
                            <Message messageKey={'change_status_state'} sectionId={MessageSections.ORDERS} />
                        </BarekamText>}
                    variant={'outlined'}
                    value={selectedState?.orderStateId || ''}
                    type={"standard"}
                    onChange={(event) => onStateSelect(event.target.value as number)}
                    error={!!errors['change_status_state']}
                    errorMessage={errors['change_status_state'] && getMessage(errors['change_status_state'], MessageSections.ORDERS, messageCache, languageId)}
                    fullWidth
                    required>
                    {filteredStates.map(state =>
                        <MenuItem value={state.orderStateId}
                            key={state.orderStateId}>
                            <Message messageKey={state.name} sectionId={MessageSections.ORDERS} />
                        </MenuItem>
                    )}
                </BarekamSelect>

                {selectedState?.orderStateId === OrderStatesEnum.inIntermediateWarehouse && (
                    <BarekamSelect
                        variant={'outlined'}
                        placeholder={getMessage('destination', MessageSections.ORDERS, messageCache, languageId)}
                        value={warehouseId}
                        onChange={(event) => setWarehouseId(event.target.value as number)}
                        type={"standard"}
                        error={!!errors['destination']}
                        errorMessage={errors['destination'] && getMessage(errors['destination'], MessageSections.ORDERS, messageCache, languageId)}>
                        {warehouses.map((warehouse, index) => {
                            if (groupData?.destination?.warehouseId === warehouse.warehouseId) {
                                return (
                                    <SelectedBarekamMenuItem value={warehouse.warehouseId}
                                        key={index}>
                                        <Message messageKey={warehouse.city} sectionId={MessageSections.MAIN} />
                                    </SelectedBarekamMenuItem>
                                )
                            } else {
                                return (
                                    <BarekamMenuItem value={warehouse.warehouseId}
                                        key={index}>
                                        <Message messageKey={warehouse.city} sectionId={MessageSections.MAIN} />
                                    </BarekamMenuItem>
                                );
                            }
                        })}
                    </BarekamSelect>
                )}
            </ActionDialogContent>

            <StandardDialogFooter saveLabel={<Message messageKey={'save'} sectionId={MessageSections.ORDERS} />}
                onSave={() => checkForSelectedState()}
                onCancel={() => onCancel()} />
        </>
    );
}

interface StateSelectDialogProps {
    onSave: (orderStateId: number, warehouseId?: number) => void,
    onCancel: () => void,
    orderStateId: number | string | undefined,
    groupData?: OrderGroupModel,
    error?: { [key: string]: string }
}

export default StateSelect;